import React from 'react';
import { Redirect } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

const Callback: React.FC = () => {
    const auth = useAuth();

    if (auth.error) {
        return <div>Error: {auth.error.message}</div>;
    }

    if (auth.isAuthenticated) {
        return <Redirect to={{ pathname: '/' }} />;
    }

    return <div>Logging in...</div>;
};

export default Callback;
